<h2 mat-dialog-title data-test="dialog">{{ data.title }}</h2>
<div mat-dialog-content>
  <agr-form [formGroup]="formGroup">
    <div class="spacing--margin-vertical">
      <agr-extended-notification
        notificationType="info"
        [title]="'cycle-overview.upload-csv-notification' | translate"
        [message]="'cycle-overview.upload-csv-message' | translate"
      ></agr-extended-notification>
    </div>
    <div>
      <mat-form-field class="spacing--margin-top">
        <mat-label class="text--small text--gray">
          {{ 'cycle-overview.cycle' | translate }}
        </mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          placeholder="{{ 'cycle-overview.placeholder' | translate }}"
          data-test="csv-import__cycle-selector"
          formControlName="cycleControl"
          (selectionChange)="changeCycleSelection($event)"
        >
          <mat-option *ngFor="let cycle of cycles$ | async" [value]="cycle">
            {{ cycle.cycleNumber }}
            {{ !!cycle.cycleDate ? '(' + (cycle.cycleDate | agrDate: 'dd-MM-yyyy') : '' }}
            {{
              !!cycle.cycleEndDate
                ? '-' + (cycle.cycleEndDate | agrDate: 'dd-MM-yyyy' + ')')
                : !!cycle.cycleDate
                  ? ')'
                  : ''
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="spacing--margin-top">
        <mat-label>{{ 'barn' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="barnControl"
          placeholder="{{ 'barn' | translate }}"
          data-test="select-barn"
        >
          <mat-option *ngFor="let barn of barns" [value]="barn" data-test="barns-item">
            {{ barn.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="spacing--margin-top">
        <mat-label>{{
          'cycle-overview.weekregistration-select-interval-type' | translate
        }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="intervalTypeControl"
          placeholder="{{ 'cycle-overview.weekregistration-select-interval-type' | translate }}"
          data-test="select-interval-type"
        >
          <mat-option
            *ngFor="let intervalType of intervalTypes"
            [value]="intervalType"
            data-test="intervalTypes-item"
          >
            {{ 'interval-type-' + intervalType | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="spacing--margin-bottom">
      <button type="button" mat-stroked-button (click)="file.click()" data-test="file-button">
        {{
          selectedFile
            ? selectedFile.name
            : ('cycle-overview.weekregistration-select-file' | translate)
        }}
      </button>
    </div>
    <input
      hidden
      (change)="onFileSelected()"
      #file
      type="file"
      accept=".csv"
      data-test="file-input"
    />
  </agr-form>
</div>
<div mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile"
    (click)="
      confirm({
        file: selectedFile,
        barnId: formGroup.get('barnControl')?.value.id,
        cycleId: formGroup.get('cycleControl')?.value.id,
        intervalType: formGroup.get('intervalTypeControl')?.value,
      })
    "
    data-test="dialog-submit"
  >
    {{ data.confirmButtonText }}
  </button>
  <button mat-stroked-button data-test="dialog-cancel" (click)="cancel()">
    {{ data.cancelButtonText }}
  </button>
</div>
